
// import "./header.css";
import { Helmet } from "react-helmet";
import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa";
import { motion, AnimatePresence } from "framer-motion";


export default function Header() {

  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const menuVariants = {
    hidden: { opacity: 0, y: -25 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.35, ease: "easeOut" },
    },
    exit: { opacity: 0, y: -25, transition: { duration: 0.25 } },
  };


const scrollToSection = (id) => {

  if (location.pathname !== "/") {
    navigate("/", { state: { scrollTo: id } });
  } else {
    const el = document.getElementById(id);
    if (el) {
      window.scrollTo({
        top: el.offsetTop - 90,
        behavior: "smooth",
      });
    }
  }

  setMenuOpen(false);
};

  const navLinks = [
  { name: "About", path: "/about" },
  {name:"How We Work",path:"/work"},
  { name: "Services", id: "services" },
  { name: "Products", path: "/products" },
  // { name: "Expertise", id: "expertise" },
  { name: "Our Value", id: "ourvalue" }, 

  // { name: "Hire Developers", id: "hire" },
  { name: "Contact Us", path: "/contact" },
  ];
  

  return (


<header className="w-full sticky top-0 z-50 bg-white backdrop-blur-xl border-b border-gray-200">

<Helmet>
    <meta charset="UTF-8" />
    <link rel="icon" href="/img/CML_LOGO.png" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <meta name="theme-color" content="#000000" />
    <meta
      name="description"
      content="Chain Magician Lab - Your one-stop solution for all software requirements. We specialize in blockchain development, including Ethereum development and smart contracts. Our mobile application services cover e-commerce apps, gaming apps, Web3 apps, and more. We also provide custom software solutions tailored to your business needs, along with decentralized application development and secure, scalable software solutions."
    />
    <title>
      Chain Magician Lab | Blockchain, Mobile & Custom Software Development
    </title>
    <meta property="og:type" content="website" />
    <meta property="og:url" content="https://www.chainmagicianlab.com/" />
    <meta
      property="og:title"
      content="Chain Magician Lab | Blockchain, Mobile & Custom Software Development"
    />
    <meta
      property="og:description"
      content="Chain Magician Lab offers high-quality blockchain development, mobile app creation including e-commerce, gaming, and Web3 apps, and custom software solutions to meet your business needs."
    />
    <meta
      property="og:image"
      content="https://www.chainmagicianlab.com/img/CML_LOGO.png"
    />
    <meta property="twitter:card" content="summary_large_image" />
    <meta
      property="twitter:url"
      content="https://www.chainmagicianlab.com/"
    />
    <meta
      property="twitter:title"
      content="Chain Magician Lab | Blockchain, Mobile & Custom Software Development"
    />
    <meta
      property="twitter:description"
      content="Chain Magician Lab provides comprehensive software solutions including blockchain development, mobile apps (e-commerce, gaming, Web3), custom software, decentralized applications, and smart contracts."
    />
    <meta
      property="twitter:image:alt"
      content="https://www.chainmagicianlab.com/img/CML_LOGO.png"
    />
    <link rel="canonical" href="https://www.chainmagicianlab.com/" />
    <meta
      name="keywords"
      content="Blockchain development, Blockchain development company in India, Best blockchain company, Ethereum development services, Smart contract development, Smart contract developers India, dApp development company, Decentralized application development, Crypto exchange development India, Centralized exchange (CEX) development, Decentralized exchange (DEX) development, DEX aggregator platform, DEX liquidity pools, DEX security audits, DEX smart contracts, Cross-chain DEX development, Crypto arbitrage trading, Yield farming platform development, DeFi development company, DeFi staking platforms, DeFi lending protocols, DeFi token development, Cryptocurrency development, Crypto coin development, Crypto wallet development, Mobile crypto wallets, Web crypto wallets, Custodial and non-custodial wallets, ICO development company, STO development company, Token development services, Top token development company India, ERC-20 token development, BEP-20 token development, NFT token development, NFT marketplace development India, NFT smart contract solutions, NFT game development, Play-to-earn game development, NFT launchpad development, Tokenomics consulting, Token audit services, Token liquidity management, Token sale strategy, Token staking platform, Token governance models, Web3 integration company, Web3 application development, Web3 wallets, Web3 projects, Web3 APIs, Web3 infrastructure solutions, Web3 scalability, Web3 consulting India, Decentralized web solutions, DAO development services, Metaverse development company, Blockchain in healthcare India, Blockchain in supply chain India, Blockchain in fintech India, Blockchain consulting services, Blockchain architecture design, Blockchain protocol development, Blockchain auditing company, Blockchain security testing, Private blockchain development, Hyperledger development, Enterprise blockchain solutions, Blockchain IoT integration, AI and blockchain solutions, MLM software development company India, Best MLM software company, MLM compensation plans, Binary MLM plan software, Matrix MLM plan development, Unilevel MLM plan, Hybrid MLM software, Forced matrix MLM, MLM income calculator India, MLM business model solutions, MLM software features, MLM strategy consulting, MLM apps development, MLM software with blockchain, MLM company reviews India, Custom MLM software solutions, Mobile app development services, iOS app development India, Android app development company, Cross-platform mobile apps, Native app development services, Enterprise mobile app development, Mobile app UI/UX design, App store optimization, Mobile app testing services, Mobile app marketing, Mobile app maintenance, App deployment services, Custom mobile application solutions, Custom software development, Software development company in India, Enterprise software development, SaaS development company, PaaS development, Cloud software solutions, Software consulting India, Software modernization services, Bespoke software development, Software integration solutions, E-commerce website development India, Shopify development company India, Magento development, WooCommerce development, Custom e-commerce app development, Multi-vendor marketplace India, Online store development, E-commerce strategy consulting, E-commerce SEO services, Gaming app development company, Unity game development India, Unreal Engine game development, VR game development, AR game development, 2D game development, 3D game development, Multiplayer game apps, Educational game apps, Casual game development, Indie game development, Game monetization strategy, Blockchain gaming solutions, Play-to-earn game apps, Web3 gaming platforms, Crypto game development, Best blockchain consulting company India, Top blockchain companies in India, Best token development services, Crypto exchange developers India, Web3 developers India, Mobile app developers India, Custom software company India, Blockchain startup solutions, Token launch services, ICO launch company India.
"
    ></meta>
    <script type="application/ld+json">
      {`
{
"@context": "https://schema.org",
"@type": "Organization",
"name": "Chain Magician Lab",
"url": "https://www.chainmagicianlab.com",
"logo": "https://www.chainmagicianlab.com/img/CML_LOGO.png",
"tagline": "Magic in every line of software.",
"description": "Chain Magician Lab specializes in blockchain development, Web3 integration, custom software, mobile apps, ecommerce apps, gaming apps, AI, and IoT solutions. We deliver innovative technology with strong expertise and nation-first vision.",
"founder": {
"@type": "Person",
"name": "Anmol",
"jobTitle": "Founder"
},
"contactPoint": [
{
  "@type": "ContactPoint",
  "telephone": "+91-6393561379",
  "contactType": "customer support",
  "areaServed": "IN",
  "availableLanguage": ["English", "Hindi"]
},
{
  "@type": "ContactPoint",
  "email": "chainmagicianlab@gmail.com",
  "contactType": "sales",
  "areaServed": "IN"
}
],
"address": {
"@type": "PostalAddress",
"addressCountry": "India"
},
"sameAs": [
"https://www.linkedin.com/company/chain-magician-lab",
"https://twitter.com/chainmagicianlab",
"https://t.me/decryptcoders"
],
"makesOffer": [
{
  "@type": "Offer",
  "itemOffered": {
    "@type": "Service",
    "name": "Blockchain Development",
    "description": "End-to-end blockchain solutions, custom smart contracts, and decentralized applications."
  }
},
{
  "@type": "Offer",
  "itemOffered": {
    "@type": "Service",
    "name": "Web3 Integration",
    "description": "Seamless wallet integration, dApps, NFT marketplaces, and DeFi solutions."
  }
},
{
  "@type": "Offer",
  "itemOffered": {
    "@type": "Service",
    "name": "Custom Software Development",
    "description": "Bespoke software tailored for businesses across industries."
  }
},
{
  "@type": "Offer",
  "itemOffered": {
    "@type": "Service",
    "name": "Mobile Application Development",
    "description": "iOS, Android, Flutter, and React Native apps with modern UI/UX."
  }
},
{
  "@type": "Offer",
  "itemOffered": {
    "@type": "Service",
    "name": "Ecommerce App Development",
    "description": "Secure and scalable ecommerce applications with payment integration."
  }
},
{
  "@type": "Offer",
  "itemOffered": {
    "@type": "Service",
    "name": "Gaming Application Development",
    "description": "High-performance game development with Web3 and traditional support."
  }
},
{
  "@type": "Offer",
  "itemOffered": {
    "@type": "Service",
    "name": "AI & Machine Learning Solutions",
    "description": "AI-driven software, predictive analytics, and intelligent automation."
  }
},
{
  "@type": "Offer",
  "itemOffered": {
    "@type": "Service",
    "name": "IoT Solutions",
    "description": "Smart IoT development with focus on industrial and defense applications."
  }
}
]
}
`}
    </script>
  </Helmet>

<div className="max-w-[1400px] mx-auto flex items-center justify-between px-5 md:px-8 h-[72px]">

  {/* Logo */}
  <Link to="/" className="flex items-center gap-2 group">
    <img
      src="/img/CML_LOGO.png"
      alt="logo"
      className="h-11 w-11 md:h-14 md:w-14 transition-transform duration-300 group-hover:scale-110"
    />
  </Link>

  {/* Desktop Menu */}
  <nav className="hidden md:flex items-center gap-9 text-[15px] font-semibold text-gray-700">

{navLinks.map((link, i) =>
  link.path ? (
    <Link key={i} to={link.path} className="relative group">
      {link.name}
      <span className="absolute left-0 -bottom-1 h-[2px] w-0 bg-green-600 transition-all duration-300 group-hover:w-full"></span>
    </Link>
  ) : (
    <button
      key={i}
      onClick={() => scrollToSection(link.id)}
      className="relative group"
    >
      {link.name}
      <span className="absolute left-0 -bottom-1 h-[2px] w-0 bg-green-600 transition-all duration-300 group-hover:w-full"></span>
    </button>
  )
)}

  </nav>

  {/* CTA Button */}
  <div className="hidden md:block">
    <button className="relative px-5 py-2.5 text-sm font-semibold text-white rounded-lg bg-[#19bd26] shadow-md transition-all duration-300 hover:shadow-lg hover:scale-105">
      Let's Talk
    </button>
  </div>

  {/* Mobile Menu Button */}
  <div className="md:hidden">
    <button
      onClick={() => setMenuOpen(!menuOpen)}
      className="text-xl text-gray-700"
    >
      {menuOpen ? <FaTimes /> : <FaBars />}
    </button>
  </div>

</div>

{/* Mobile Menu */}

<AnimatePresence>
  {menuOpen && (
    <motion.div
      variants={menuVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
      className="md:hidden absolute top-[72px] left-0 w-full bg-white shadow-xl border-t border-gray-200"
    >

      <div className="flex flex-col gap-6 px-6 py-8 text-gray-700 font-medium">

        {navLinks.map((link, i) =>
          link.path ? (
            <Link
              key={i}
              to={link.path}
              onClick={() => setMenuOpen(false)}
              className="hover:text-green-600 transition"
            >
              {link.name}
            </Link>
          ) : (
            <button
              key={i}
              onClick={() => scrollToSection(link.id)}
              className="text-left hover:text-green-600 transition"
            >
              {link.name}
            </button>
          )
        )}

        <button className="mt-2 bg-[#19bd26] text-white py-2.5 rounded-lg font-semibold hover:opacity-90 transition">
          Let's Talk
        </button>

      </div>

    </motion.div>
  )}
</AnimatePresence>

</header>

    
  );
}
